import React from "react";
import {
  ToggleWrapper,
  ToggleSlider,
  ToggleHandle,
} from "./ToggleButton.styles";
import { ToggleButtonProps } from "./ToggleButton.types";

export const ToggleButton: React.FC<ToggleButtonProps> = ({
  checked = false,
  disabled = false,
  onChange,
}) => {
  return (
    <ToggleWrapper checked={!!checked} disabled={!!disabled}>
      <ToggleSlider
        checked={!!checked}
        disabled={!!disabled}
        onClick={!disabled ? onChange : undefined}
      >
        <ToggleHandle checked={!!checked} disabled={!!disabled} />
      </ToggleSlider>
    </ToggleWrapper>
  );
};
